import React, {useRef, useEffect} from "react";
import styles from "./ProductCarousel.module.scss";
import TinySlider from "tiny-slider-react";
import {products} from "../CustomWraps.data";
import {useDispatch, useSelector} from "react-redux";
import wrapStyles from "components/homePanels/l_customWraps/CustomWraps.module.scss";
import {buttonClick} from "utils/Helpers";

const ProductCarousel = (props) =>  {

    const wrapSelection = useSelector(state => state.wrapSelection);
    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch();
    const clickAction = useRef();
    const activeElement = useRef();
    const tinySlider = useRef();
    const prev = useRef();
    const next = useRef();

    const tinyCarouselSettings = {
        lazyload: true,
        nav: false,
        mouseDrag: true,
        controls: false,
        loop: false,
        startIndex: 0,
        responsive: {
            0: {
                items: 2
            },
            400: {
                items: 3
            },
            800: {
                items: 5
            }
        }
    }

    useEffect(()=>{

        setTimeout(()=>{

            if(prev.current) prev.current.disabled = true;

            if(tinySlider.current) tinySlider.current.slider.events.on('indexChanged', (e)=>{
                let sliderInfo = tinySlider.current.slider.getInfo();
                next.current.disabled = sliderInfo.slideCount === (sliderInfo.items + sliderInfo.index);
                prev.current.disabled = sliderInfo.index === 0;
            })

        }, 100)

    }, [])

    function keyboardSelection(index){
        tinySlider.current.slider.goTo(index);

        dispatch({ type: "SET_WRAP_SELECTION",
            payload: {
                ...wrapSelection,
                product: products[index]
            }
        });
        clickAction.current = true;
    }

    function goToSlideAndProduct(index) {

        if(clickAction.current){

            tinySlider.current.slider.goTo(index);

            dispatch({ type: "SET_WRAP_SELECTION",
                payload: {
                    ...wrapSelection,
                    product: products[index]
                }
            });

        } else {
            activeElement.current.removeEventListener('mousemove', setClickFalse);
        }

    }

    function setClickFalse(){
        clickAction.current = false
    }

    function dragOrClick(e){

        activeElement.current = e.currentTarget;
        clickAction.current = true;
        activeElement.current.addEventListener('mousemove', setClickFalse);

    }

    function ariaHidden (){
        return (wrapSelection.product && !wrapSelection.design) || (!wrapSelection.product && wrapSelection.design)
    }

    return (
        <div aria-hidden={ariaHidden()} className={`${wrapStyles.wrapsBlade} ${wrapStyles.productCarousel}`}>
            <h4 ref={props.titleFocus} tabIndex={-1}>Select your Surface</h4>
            <div className={styles.tinySliderContainer}>
                <button disabled={accessible.modalOpen} ref={prev} className={styles.prev}  onClick={()=>tinySlider.current.slider.goTo('prev')} >
                    <img src="https://msobd-storage.azureedge.net/images/customWraps/arrow.png" alt="Previous Product" />
                </button>
                <TinySlider
                    settings={tinyCarouselSettings}
                    ref={tinySlider}
                >
                    {products.map((p, i) => (
                        <div key={i} className={styles.item} >
                            <div tabIndex={!accessible.modalOpen ? 0 : null} role={!accessible.modalOpen ? 'button' : null} aria-label={p.name.replace('&nbsp;', ' ')}
                                 onKeyDown={(e)=>buttonClick(e, ()=>keyboardSelection(i))}
                                 onMouseDown={(e)=>dragOrClick(e)}
                                 onMouseUp={() => goToSlideAndProduct(i)}>
                                <img aria-hidden={true} src={p.image} alt={p.name.replace('&nbsp;', ' ')}
                                     className={(wrapSelection.product && (wrapSelection.product.name === p.name)) ? styles.selected : ''}/>
                                <div aria-hidden={true} className={(wrapSelection.product && (wrapSelection.product.name === p.name)) ? styles.selected : ''}
                                     index={i} dangerouslySetInnerHTML={{__html:p.name.replace('&nbsp;', ' ')}}/>
                            </div>

                        </div>
                    ))}
                </TinySlider>
                <button disabled={accessible.modalOpen} role={!accessible.modalOpen ? 'button' : null} ref={next} className={styles.next}  onClick={()=>tinySlider.current.slider.goTo('next')}>
                    <img src="https://msobd-storage.azureedge.net/images/customWraps/arrow.png" alt="Next Product" />
                </button>
            </div>
        </div>
    )
}

export default ProductCarousel;
